import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, Calendar, UserPlus } from 'lucide-react';
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  
  return (
    <header className="header">
      <div className="header-container">
        {/* <button 
          onClick={() => navigate(-1)} 
          className="back-button"
          aria-label="Назад"
        >
          <ArrowLeft className="icon" />
        </button> */}
        
        <Link to="/" className="home-link">
          <Home className="icon" />
          <span className="sr-only">Главная</span>
        </Link>

        <nav className="header-nav">
          <ul className="nav-list">
            <li className="nav-item">
              <a href="#Streams" className="nav-link">
                <Calendar className="nav-icon" />
                <span>Потоки</span>
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="https://forms.yandex.ru/u/687927fd90fa7b08812f434c/%5C%5C" 
                target="_blank" 
                rel="noopener noreferrer"
                className="nav-link register-link"
              >
                <UserPlus className="nav-icon" />
                <span>Регистрация</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;